import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { volumes, startHere, insideEveryVolume } from '../data/volumes';
export function Volumes() {
  return <section aria-labelledby="volumes-heading" className="bg-paper" data-id="element-246" data-mp="185gdy9p208qs">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 md:py-28" data-id="element-247" data-mp="1c4p8vhvtycnx">
        <h2 id="volumes-heading" className="max-w-[38rem] font-serif text-[30px] font-semibold leading-[1.12] tracking-[-0.015em] text-ink md:text-[44px]" data-id="element-248" data-mp="1zvb2i4537uee">
          The six volumes
        </h2>
        <p className="mt-5 max-w-[40rem] text-[17px] leading-[1.65] text-slate md:text-[18px]" data-id="element-249" data-mp="1qv69iz0n4yjr">
          Each volume is a working section of the program, not a chapter of theory. Read them in
          order or open the one that is on fire today.
        </p>

        <ul className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-250" data-mp="keay3uj45ggh">
          {volumes.map(volume => <li key={volume.number} className="relative flex flex-col border border-brass/30 bg-white p-7 shadow-paper rounded-sharp md:p-8" data-id="element-251" data-mp="kby9iyiuo7ug">
              {volume.featured && <span className="absolute right-0 top-0 bg-brass px-3 py-1.5 font-mono text-[10px] uppercase leading-none tracking-label text-ink" data-id="element-252" data-mp="21ht49wh5fio">
                  ★ The heart of the system
                </span>}

              <span className="inline-block self-start bg-brass px-2.5 py-1 font-mono text-[10px] uppercase leading-none tracking-label text-ink rounded-sharp" data-id="element-253" data-mp="b0bxwnjylc7b">
                {volume.number}
              </span>

              <h3 className="mt-5 max-w-[22rem] font-serif text-[23px] font-semibold leading-[1.2] text-ink md:text-[26px]" data-id="element-254" data-mp="kqwq9t91hkhs">
                {volume.title}
              </h3>

              <p className="mt-2 font-serif text-[17px] italic text-slate" data-id="element-255" data-mp="tt62qonvbnxt">{volume.subtitle}</p>

              <p className="mt-5 flex-1 text-[16px] leading-[1.65] text-slate" data-id="element-256" data-mp="prkhaex9q1c0">
                {volume.body.map((part, index) => part.bold ? <strong key={index} className="font-semibold text-ink" data-id="element-257" data-mp="11skhyv309210">
                      {part.text}
                    </strong> : <React.Fragment key={index} data-id="element-258" data-mp="16qm1ti8995dj">{part.text}</React.Fragment>)}
              </p>

              <p className="mt-7 border-t border-brass/25 pt-4 font-mono text-[12px] leading-[1.5] text-brass" data-id="element-259" data-mp="1fk8taw5fjmgx">
                {volume.promise}
              </p>
            </li>)}
        </ul>

        <div className="mt-12 border-l-[3px] border-brass bg-white px-7 py-7" data-id="element-260" data-mp="1pioaa6aqtfcp">
          <p className="font-mono text-[10px] uppercase tracking-label text-brass" data-id="element-261" data-mp="1pgk8btwemqf2">
            {startHere.label}
          </p>
          <h3 className="mt-3 font-serif text-[22px] font-semibold text-ink md:text-[26px]" data-id="element-262" data-mp="3rab3mei3xmcc">
            {startHere.title}
          </h3>
          <p className="mt-3 max-w-[44rem] text-[16px] leading-[1.65] text-slate" data-id="element-263" data-mp="409l2billui">
            {startHere.body}
          </p>
        </div>

        <div className="mt-12" data-id="element-264" data-mp="28n1hxa5wsbfs">
          <h3 className="font-mono text-[10px] uppercase tracking-label text-slate" data-id="element-265" data-mp="28mrotdpkho5v">
            {insideEveryVolume.title}
          </h3>
          <ul className="mt-5 grid gap-3" data-id="element-266" data-mp="24loaivn6406r">
            {insideEveryVolume.items.map(item => <li key={item} className="flex gap-3" data-id="element-267" data-mp="1zo6ajur4ovaw">
                <CheckIcon className="mt-[5px] h-4 w-4 shrink-0 text-brass" strokeWidth={2.5} aria-hidden="true" data-id="element-268" data-mp="2wcvudqmbfxzi" />
                <span className="text-[16px] leading-[1.6] text-slate" data-id="element-269" data-mp="2nbnx9bvjd370">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="mt-14" data-id="element-270" data-mp="2icbb6tcho05h">
          <CtaButton data-id="element-271" data-mp="2if776c4s0era">See everything included — $27</CtaButton>
          <TrustRow className="mt-4" data-id="element-272" data-mp="1bxk76gs2jz78" />
        </div>
      </div>
    </section>;
}